import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import { Injectable } from '@angular/core';
import { CustomHeaders } from '@aws-amplify/data-schema-types';

export type ExecuteGQLResult = {
  errors: { message: string }[],
  data: any
};
export type QueryVariableType = string | number | boolean | null | { [key: string]: QueryVariableType };
export type QueryVariables = { [key: string]: QueryVariableType };
export type QueryResult = {
  error?: string | null,
  data?: string | number | { [key: string]: any } | null
};
type GqlData = { [key: string]: string | number | any | null };

const GRAPHQL_API_URL = '/graphql';
const REGION = 'eu-central-1';

@Injectable({
  providedIn: 'root'
})
export class BackendService {

  private readonly hostname: string;
  private authToken: string | null = null;
  private gqlClient: any = null;

  constructor() {
    this.hostname = window.location.hostname;
    console.log('BackendService.hostname: ', this.hostname);

    Amplify.configure({
      API: {
        GraphQL: {
          endpoint: `https://${this.hostname}${GRAPHQL_API_URL}`,
          region: REGION,
          defaultAuthMode: 'apiKey',
          apiKey: 'x'
        }
      }
    });
    this.gqlClient = generateClient();
  }

  getHostname(): string {
    return this.hostname;
  }

  setAuthToken(token: string | null): void {
    if (token) {
      const expirationDate = new Date();
      const expirationDays = 7;
      expirationDate.setDate(expirationDate.getDate() + expirationDays);
      const expires = `expires=${expirationDate.toUTCString()}`;
      const cookieVal = `authToken=${token}; Path=/; ${expires}; SameSite=strict; Secure;`;
      //console.log('cookieVal', cookieVal);
      document.cookie = cookieVal;
      //console.log('cookies: ' + document.cookie);
    } else {
      // delete the cookie
      document.cookie = 'authToken=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    this.authToken = token;
  }

  async executeGraphQL(query: string, variables: QueryVariables): Promise<QueryResult> {
    let additionalHeaders: CustomHeaders = {
      'X-Api-Key': 'x'
    };
    if (this.authToken != null) {
      additionalHeaders = {
        ...additionalHeaders,
        'X-Api-Key': 'a',
        Authorization: `${this.authToken}`
      }
    }

    try {
      console.log(
        `executeGraphQL.prepared ${this.authToken ? '(user authenticated)' : ''}`,
        {query: query.replaceAll('\n', ' '), variables, additionalHeaders}
      );
      const data = await this.gqlClient.graphql({
          query,
          variables
        },
        additionalHeaders
      ) as ExecuteGQLResult;
      // console.log(`executeGraphQL.data:  ${JSON.stringify(data)}`);
      if (data.errors != null && data.errors[0].message) {
        return {error: data.errors[0].message};
      }
      if (data.data == null) {
        return {error: JSON.stringify(data)};
      }
      return {data: data.data};
    } catch (err) {
      console.error(`error executing GraphQL: ${JSON.stringify(err)}`);
      const error = err as Error;
      return {error: error.message};
    }
  }

}
